import moment from "moment";

import { StatusText, valueStrings } from "constants/constantStrings";
import {
  ADD_BASELINE_DATE_FORMAT,
  DATE_FORMAT,
  DATE_FORMAT_WITH_BITWISEOR,
  DATE_TIME_SECONDS_FORMAT,
  LOCAL_TZ_CODE
} from "constants/globalConstants";
import { SYSTEM_STATUS } from "constants/systemStatus";
import gaugeFormConfig from "components/GaugeWidgetForm/gauge.form.config";
let currentSystemId;


export const updateSystemId = systemId => {
  if (systemId !== undefined) currentSystemId = systemId;
};

export const extractSystemId = () => currentSystemId;
export const checkOwnProperty = (obj, key) => Object.prototype.hasOwnProperty.call(obj, key);
export const isLandingPage = () => window.location.pathname.endsWith("/home");

export const getPage = () => {
  const url = window.location.pathname.split("/");
  const page = url[3]; // get the page name dashboard/charts/report
  // page = page.charAt(0).toUpperCase() + page.slice(1); // capitalize first letter
  return page;
};


export const loadExternalScript = (url) => {
  const script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};

export const getLayout = currentLayout => {
  const sysID = extractSystemId();
  if (!currentLayout || !currentLayout[sysID]) {
    return null;
  }

  const page = getPage();
  return currentLayout[sysID][page];
};

export const extractLayout = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const layout = decodeURIComponent(queryParams.get("layout"));
  return layout;
};

export const extractCurrentTabFromURL = () => {
  const queryParams = new URLSearchParams(window.location.search);
  const currentTab = decodeURIComponent(queryParams.get("currentTab"));
  return currentTab;
};

export const camelize = str =>
  str.replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => (index === 0 ? word.toLowerCase() : word.toUpperCase())).replace(/\s+/g, "");

export const camelizeObjectKeys = data => {
  Object.keys(data).forEach(property => {
    if (checkOwnProperty(data, property)) {
      const camelizedProperty = camelize(property);
      if (property !== camelizedProperty) {
        Object.defineProperty(data, camelizedProperty, Object.getOwnPropertyDescriptor(data, property));
        delete data[property];
      }
    }
  });
};

export const capitalizeFirstLetter = str => str.charAt(0).toUpperCase() + str.slice(1);

export const capitalizeObjectKeys = object => {
  Object.keys(object).forEach(property => {
    if (checkOwnProperty(object, property)) {
      const capitalizedProperty = capitalizeFirstLetter(property);
      // if(object[property] === null) delete object[property];
      if (property !== capitalizedProperty) {
        Object.defineProperty(object, capitalizedProperty, Object.getOwnPropertyDescriptor(object, property));
        delete object[property];
      }
    }
  });
};

export const capitalizeJson = someObject => {
  if (someObject && Array.isArray(someObject)) {
    someObject.forEach(elem => capitalizeJson(elem));
  } else if (someObject && typeof someObject === "object" && someObject !== null) {
    capitalizeObjectKeys(someObject);
    Object.keys(someObject).forEach(property => {
      if (checkOwnProperty(someObject, property)) {
        capitalizeJson(someObject[property]);
      }
    });
  }
};

export const camelizeJson = someObject => {
  if (someObject && Array.isArray(someObject)) {
    someObject.forEach(elem => camelizeJson(elem));
  } else if (someObject && typeof someObject === "object" && someObject !== null) {
    camelizeObjectKeys(someObject);
    Object.keys(someObject).forEach(property => {
      if (checkOwnProperty(someObject, property)) {
        camelizeJson(someObject[property]);
      }
    });
  }
};

export const handleApiErrorThrowResponse = err => {
  if (checkOwnProperty(err, "response")) {
    camelizeJson(err.response);
    throw err;
  } else {
    throw err;
  }
};

export const validateEmail = email => {
  const emailFormat = /^(\w|\.|_|-)+[@](\w|_|-|\.)+[.]\w{2,3}$/;
  return emailFormat.test(email);
};

export const prepareSystemsStatus = (systemName, systemsStatus) => {
  let status;
  if (systemName !== null && systemName !== "") {
    if (systemsStatus.length > 1) {
      let systemIndex = 0;
      systemsStatus.forEach((sys, index) => {
        if (sys.systemName === systemName) {
          systemIndex = index;
        }
      });
      status = systemsStatus[systemIndex].connectionStatus;
    }
    if (systemsStatus.length === 1 && systemsStatus[0] !== null) {
      status = systemsStatus[0].connectionStatus;
    }
  }
  return status;
};

const formatTag = (Tags, idx) => {
  let formattedTag = null;
  if (Tags && Tags[idx]) {
    const { TagId, TagName, Units, Value } = Tags[idx];
    if (TagName) {
      formattedTag = { TagId, TagName, Units, Value };
    }
  }
  return formattedTag;
};

export const formatTagsData = Tags => {
  const data = {};
  if (Tags) {
    const tagsLen = Tags.length;
    if (tagsLen === 1) {
      data[`Tag1`] = formatTag(Tags, 0);
    } else {
      for (let count = 0; count < tagsLen; count++) {
        data[`Tag${count + 1}`] = formatTag(Tags, count);
      }
    }
  }
  return data;
};

export const getLayoutURL = (page, layout) => {
  const id = layout && checkOwnProperty(layout, "ID");
  const url = id ? `${page}/${layout.ID}` : `/${page}`;
  return url;
};

// must be reviewed, sytems select page shows a different status
export const prepareConnectionStatus = (systemName, systemsStatus) => {
  let connectionStatus;
  if (systemName) {
    const systemConnectionStatus = systemsStatus.find(sys => sys.systemName === systemName);
    connectionStatus = systemConnectionStatus && systemConnectionStatus.systemStatus;
  }
  return connectionStatus;
};

export const dateRangeFilter = {
  filterOptions: ["equals", "notEqual", "lessThan", "lessThanOrEqual", "greaterThan", "greaterThanOrEqual", "inRange"],
  buttons: ["apply", "reset"],
  closeOnApply: true,
  comparator: (filterLocalDateAtMidnight, cellValue) => {
    let finalVal;
    if (cellValue === "-") {
      finalVal = -1;
    } else {
      const lastIndex = cellValue.lastIndexOf(" ");
      const newCellValue = cellValue.slice(0, lastIndex + 1);
      const cellDate = moment(newCellValue).startOf("date").toDate();
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        finalVal = 0;
      } else if (cellDate < filterLocalDateAtMidnight) {
        finalVal = -1;
      } else if (cellDate > filterLocalDateAtMidnight) {
        finalVal = 1;
      }
    }
    return finalVal;
  }
};

export const customDebounce = func => {
  let timer;
  return function (...args) {
    const context = this;
    if (timer) clearTimeout(timer);
    timer = setTimeout(() => {
      timer = null;
      func.apply(context, args);
    }, 300);
  };
};

export const saveDisplayDates = (startDateDisplay, endDateDisplay) => {
  sessionStorage.setItem("startDateDisplay", startDateDisplay);
  sessionStorage.setItem("endDateDisplay", endDateDisplay);
};

export const getStartDate = () => {
  const savedStartDateString = sessionStorage.getItem("startDate");
  let savedStartDate;
  if (savedStartDateString) {
    savedStartDate = new Date(savedStartDateString);
  } else {
    savedStartDate = new Date();
    savedStartDate.setDate(savedStartDate.getDate() - 1);
  }
  const startDate = moment(savedStartDate, "DD-MMM-YYYY hh:mm:ss", moment.defaultFormat);
  return startDate;
};

export const convertBoolToInt = value => +value;

export const getEndDate = () => {
  const saveddEndDateString = sessionStorage.getItem("endDate");
  let savedEndDate;
  if (saveddEndDateString) {
    savedEndDate = new Date(saveddEndDateString);
  } else {
    savedEndDate = new Date();
  }
  const endDate = moment(savedEndDate, "DD-MMM-YYYY hh:mm:ss", moment.defaultFormat);
  return endDate;
};

export const isAnywidgetEnable = reports => reports.some(report => report.Enabled);

export const populateXYaxis = (timeData, tag) => {
  const trace = {};
  trace["type"] = tag.Type || "";
  trace["x"] = timeData || "";
  trace["y"] = tag.Data || "";
  trace["name"] = tag.Name || "";
  const marker = {};
  marker["color"] = tag.Color || "";
  trace["marker"] = marker || "";
  return trace;
};

export const getFileNameDateTime = () => moment().format("DD-MMM-YYYY_HH-mm-ss");
export const getFileNameDate = () => moment().format("YYYY-MM-DD");

export const getDefaultWidgetName = () => "Widget_" + moment().format("DDMMYYHHmmss");

export const notAllZeros = arr => {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i] > 0) {
      return false;
    }
  }
  return true;
};

export const isEllipsisActive = contentRef => contentRef.current?.offsetWidth < contentRef.current?.scrollWidth;

export const formatDateWithoutTime = date => (date ? moment(date).format(DATE_FORMAT) : "");

export const formatDate = date => (date ? moment(date).format(DATE_TIME_SECONDS_FORMAT) : "");

export const timestampInDefaultFormat = ts => (ts ? moment(ts * 1000).format(ADD_BASELINE_DATE_FORMAT) : "");

export const formatTimestamp = timestamp => (timestamp ? moment.utc(new Date(timestamp)).local().format() : "");

export const formatDateLocalTZ = (date, format = DATE_TIME_SECONDS_FORMAT) => {
  let formattedDate = "-";
  if (date) {
    const localDate = moment.utc(date).local().format(format);
    formattedDate = `${localDate} ${LOCAL_TZ_CODE}`;
  }
  return formattedDate;
};

export const formatUTCofTimezone = (date, timezone) => {
  const localOffset = moment(date).utcOffset();
  const selectedTimezoneTimeOffset = moment(date).tz(timezone).utcOffset();
  const diffInMinutes = localOffset - selectedTimezoneTimeOffset;
  date = moment(date).add(diffInMinutes, "minutes").utc().unix();
  return date;
};

export const formatlocaltoTimezone = (date, timezone) => (date ? moment(date).tz(timezone).format(DATE_TIME_SECONDS_FORMAT) : "");

export const formatDateWithBitwiseOR = date => moment(date).format(DATE_FORMAT_WITH_BITWISEOR);

export const fromatDateFromBaselineFormat = date => new Date(moment(date, ADD_BASELINE_DATE_FORMAT));

export const extractCode = () => {
  const queryParams = new URLSearchParams(window.location.search);
  return queryParams.get("code");
};

export const isFIT_1_AnamolyType = type => type === "FIT1";

export const getChangedData = (updatedData, initialData) => {
  if (Array.isArray(updatedData) || updatedData === "") {
    return updatedData;
  }
  const dataDiff = {};
  for (const key in updatedData) {
    if (initialData) {
      if (typeof initialData[key] === "object") {
        dataDiff[key] = getChangedData(updatedData[key], initialData[key]);
        if (typeof dataDiff[key] === "object") {
          //need this remove && condition, BE to implement empty attribute
          if (Object.keys(dataDiff[key]).length === 0 && key !== "Attributes") {
            delete dataDiff[key];
          }
        }
      } else if (initialData[key] !== updatedData[key]) {
        dataDiff[key] = updatedData[key];
      }
    }
  }
  return dataDiff;
};
export const getTagid = (SystemTag, param) => {
  const tags = [];
  if (SystemTag) {
    if (SystemTag.TagId) {
      tags.push(SystemTag.TagId);
    } else {
      for (const key in SystemTag) {
        const isTag = key.includes("Tag");
        const value = SystemTag[key];
        if (isTag && value) tags.push(value.TagId);
      }
    }
    param = { ...param, Attributes: { ...param.Attributes, SystemTag: tags } };
  }
  return param;
};

export const userManualHandler = event => {
  if (event) event.preventDefault();
  const alink = document.createElement("a");
  alink.href = "/user-guide.pdf";
  alink.target = "_blank";
  alink.rel = "noopener noreferrer";
  alink.click();
};

export const getFiltersPayload = NormalizationFilters => {
  let result = {};
  if (NormalizationFilters) {
    result = {
      recovery_low: NormalizationFilters.RecoveryL,
      recovery_high: NormalizationFilters.RecoveryH,
      feed_flow_low: NormalizationFilters.FeedFlowL,
      feed_flow_high: NormalizationFilters.FeedFlowH,
      reject_conductivity_low: NormalizationFilters.RejectConductivityL,
      reject_conductivity_high: NormalizationFilters.RejectConductivityH
    };
  }
  return result;
};

export const getYesOrNo = value => (value ? valueStrings.yes : valueStrings.no);
export const getTrueOrFalse = value => (value === valueStrings.yes ? true : false);

export const isStringType = value => typeof value === "string";
export const isNumberType = value => !isNaN(value);
export const getFilteredTag = (allTags, selectedTags) => {
  Object.keys(selectedTags).forEach(key => {
    if (selectedTags[key] === null) {
      delete selectedTags[key];
    }
  });
  const selectedTag = Object.values(selectedTags);
  const filteredTagsList = allTags.filter(tag => !selectedTag.some(item => item.TagId === tag.TagId));
  return filteredTagsList;
};

export const systemStatusText = params => {
  if (params) {
    if (params.data.connectionStatus === SYSTEM_STATUS.STATUS_DISCONNECTED) {
      return StatusText.offline;
    } else if (params.data.systemStatus.toString() === SYSTEM_STATUS.STATUS_RUNNING) {
      return StatusText.running;
    } else if (params.data.systemStatus.toString() === SYSTEM_STATUS.STATUS_STOPPED) {
      return StatusText.idle;
    } else if (params.data.systemStatus.toString() === SYSTEM_STATUS.STATUS_ALARM) {
      return StatusText.alarming;
    }
  }
};

export const getHourMinute = date => `${date.getHours()}:${date.getMinutes()}`;

export const getGraphDataPointsInterval = DurationRanges => {
  const timestampDiff = DurationRanges.endTime - DurationRanges.startTime;
  const numdays = timestampDiff / (24 * 3600);
  let base = 90;
  let pow = 4;
  if (numdays >= 120) pow = 2.45; // >= 4 months
  else if (numdays >= 56) pow = 2.6; // >= 2 months
  else if (numdays >= 28) pow = 2.7; // >= 1 Month
  else if (numdays >= 14) pow = 3; // >= 2 week
  else if (numdays >= 7) pow = 3.3; // >= 1 week
  else if (numdays >= 3) pow = 3; // >= 3 Days
  // else if (numdays >= 3) base = ; //1 day
  else if (numdays > 1) base = 20; //12 hrs
  else base = 10;
  const group = Math.round(base + numdays / 10 + (2 * numdays) ** pow / (100 + numdays));
  return Math.round(group / 10) * 10;
};

export const sortWidgetsBasedOnOrder = widgets => {
  const widgetWithOrder = [];
  const widgetsWithoutOrder = [];
  widgets.forEach(element => {
    const list = element.Order !== null ? widgetWithOrder : widgetsWithoutOrder;
    list.push(element);
  });
  widgetWithOrder.sort((a, b) => a["Order"] - b["Order"]);
  return widgetWithOrder.concat(widgetsWithoutOrder);
};
export const getGaugeTypeText = subType => gaugeFormConfig.TYPES.find(gaugeSubType => gaugeSubType.type === subType).text;

export const getControlId = (text = "dupont", cntrlType) => {
  const label = text
    .toLowerCase()
    .replace(/\s/g, "_", "_")
    .replace(/[^a-z0-9_]/g, "");
  return cntrlType ? `${label}_${cntrlType}` : label;
};

export const getRowFormattedData = (tableColDef, data) =>
  tableColDef.reduce((result, column) => {
    if (column.field) {
      const { field, headerName: colName } = column;
      let colVal = data[field];
      if (column.valueFormatter) {
        colVal = column.valueFormatter({ data, colDef: column });
      }
      result.push({ colName, colVal });
    }
    return result;
  }, []);

export const getTwoDecimalPoint = value => {
  return value || value === 0 ? Number((Math.floor(value * 100) / 100).toFixed(2)) : "";
};
